import React, { useEffect, useState, useContext } from "react";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import { saveAs } from "file-saver";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { AiFillStar } from "react-icons/ai";
import { MdContentCopy } from "react-icons/md";
import Papa from "papaparse";
import { ImBin } from "react-icons/im";
import { IoIosRefresh } from "react-icons/io";
import {
  InputGroup,
  Dropdown,
  Popover,
  OverlayTrigger,
  Form,
} from "react-bootstrap";
import Loading from "../loader/Loading";
import { Ucontext } from "../../context/Ucontext";
import { BASE_URL, REACT_APP_URL } from "../../config/index";
import { useNavigate } from "react-router-dom";
import {
  adminLogin,
  downloadDocuSignDoc,
  downloadTinkReport,
  getTenantKycDocs,
  updateUserInfo,
  getDocumentAnalysis,
  runOrchestratorAnalysis,
  runForensic,
  hardDeleteTenant,
  viewAsLandlord,
  skorLoginAdmin,
} from "../../context/functions/AdminFunction";
import moment from "moment";
import { getClassName, haveValue } from "../../utils/common";
import { toast } from "react-toastify";
import { constants } from "../../utils/constants";
import axiosInstance from "../../services/authWrapper";
import DeleteModal from "../DeleteModal";
import CsvAnalysisReportModal from "./CsvAnalysisReportModal";

const TenantsList = (props) => {
  const {
    tenants,
    sortColumn,
    sortType,
    handleSorting,
    loadTenants,
    currentPage,
    searchVal,
    sortBy,
    filter,
    searchInputRef,
    handleShowWorkspaceInfo,
  } = props;

  const navigate = useNavigate();

  const { adminDispatch, getSingleUser, adminState, getAllTenants, authState } =
    useContext(Ucontext);
  const { totalTenants, totalProperties } = adminState;
  const { user: adminUser } = authState;

  const [RentModal, setRentModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [detailLoadingId, setDetailLoadingId] = useState(null);
  const [singleTenant, setSingleTenant] = useState();
  const [otpTenant, setOtpTenant] = useState({});
  const [showOtp, setShowOtp] = useState(false);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [summaryData, setSummaryData] = useState(null);
  const [tinkModalOpen, setTinkModalOpen] = useState(false);
  const [tinkModalData, setTinkModalData] = useState(false);
  const [csvAnalysisModalOpen, setCsvAnalysisModalOpen] = useState(false);
  const [csvAnalysisResponse, setCsvAnalysisResponse] = useState(null);
  const [deleteModal, setDeleteModal] = useState(null);
  const [isDeletingTenant, setIsDeletingTenant] = useState(false);

  const renderSortIcon = (column) => {
    if (sortColumn !== column) {
      return (
        <FaSort className="sort-icon sort-icon-default" aria-hidden="true" />
      );
    }

    return sortType === "asc" ? (
      <FaSortUp className="sort-icon sort-icon-active" aria-hidden="true" />
    ) : (
      <FaSortDown className="sort-icon sort-icon-active" aria-hidden="true" />
    );
  };

  const showOtpModal = (tenant) => {
    setOtpTenant(tenant);
    setShowOtp(true);
  };

  const handleDownloadCsv = async (tenant_id, isViewModalReport = false) => {
    setLoading(true);

    downloadTinkReport(tenant_id)
      .then(async (response) => {
        // Extract the filename from Content-Disposition
        const blob = new Blob([response.data], { type: "text/csv" });
        const contentDisposition = response.headers["content-disposition"];
        const filename = contentDisposition
          ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
          : `${tenant_id}-tink-report.csv`;

        if (isViewModalReport) {
          const formData = new FormData();
          formData.append("csv", blob, filename);

          const analysisResponse = await runOrchestratorAnalysis(formData);

          setCsvAnalysisResponse(analysisResponse);
          setCsvAnalysisModalOpen(true);
          setLoading(false);
          return;
        }

        const text = await blob.text();
        const parsed = Papa.parse(text, {
          header: true,
          skipEmptyLines: true, // Ignores blank lines
          dynamicTyping: true, // Converts numeric strings to actual numbers
          transformHeader: (header) => header.trim(), // Remove whitespace around headers
        });
        if (parsed.errors.length) {
          console.error("CSV Parsing Errors", parsed.errors);
          setLoading(false);
          return;
        }

        const rows = parsed.data;

        // Transform rows array into a column-based key-value object
        const columnData = {};

        rows.forEach((row) => {
          for (const key in row) {
            if (!columnData[key]) {
              columnData[key] = [];
            }
            columnData[key].push(row[key]);
          }
        });

        console.log("Transformed Column-Wise Data:", columnData);

        const getColumnValues = (...keys) => {
          const foundKey = keys.find((key) => Array.isArray(columnData[key]));
          return foundKey ? columnData[foundKey] : [];
        };

        const bookedDates = getColumnValues("bookedDate", "Booked Date");
        const amounts = getColumnValues(
          "amountScaledValue",
          "Amount (Scaled Value)",
        );
        const categories = getColumnValues("Category", "category");
        const subCategories = getColumnValues("SubCategory", "subCategory");

        //Getting 90 days indexes
        const today = new Date();
        const ninetyDaysAgo = new Date(today);
        ninetyDaysAgo.setDate(today.getDate() - 90);

        // Step 1: Get recent indexes
        const recentIndexes = bookedDates
          .map((dateStr, index) => {
            const date = new Date(dateStr);
            return date >= ninetyDaysAgo ? index : -1;
          })
          .filter((index) => index !== -1);

        // Step 2–5: Calculate average of absolute values
        let total = 0;
        let count = 0;

        recentIndexes.forEach((i) => {
          const rawAmount = amounts[i];
          if (!rawAmount) return;

          const absVal = Math.abs(parseFloat(rawAmount));
          if (!isNaN(absVal)) {
            total += absVal;
            count++;
          }
        });
        console.log("Total Value", total);
        const average = count > 0 ? total / count : 0;
        const total_transactions = bookedDates.length ?? 0;

        console.log("Absolute Average (last 90 days):", average.toFixed(2));

        let positiveSum = 0;
        let negativeSum = 0;

        amounts.forEach((amountStr) => {
          const value = parseFloat(amountStr);

          if (isNaN(value)) return;

          if (value > 0) {
            positiveSum += value;
          } else if (value < 0) {
            negativeSum += value; // will stay negative
          }
        });
        negativeSum = Math.abs(negativeSum);
        const totalAbsoluteSum = Math.abs(positiveSum) + Math.abs(negativeSum);

        const result = {
          income: {},
          expense: {},
        };

        for (let i = 0; i < amounts.length; i++) {
          const rawAmount = amounts[i];
          const amount = parseFloat(rawAmount);

          if (isNaN(amount)) continue;

          const absAmount = Math.abs(amount);
          const category = categories[i];
          const subCategory = subCategories[i];

          if (!subCategory) continue;

          // Normalize category
          let targetCategory;
          if (category === "Income" || category === "Regular Income") {
            targetCategory = "income";
          } else if (category === "Expense" || category === "Regular Expense") {
            targetCategory = "expense";
          } else {
            continue; // Ignore unknown category types
          }

          // Aggregate by subCategory
          if (!result[targetCategory][subCategory]) {
            result[targetCategory][subCategory] = 0;
          }

          result[targetCategory][subCategory] += absAmount;
        }

        setTinkModalData({
          object: result,
          average: average,
          total_transactions: total_transactions,
          positiveSum: positiveSum,
          negativeSum: negativeSum,
          totalAbsoluteSum: totalAbsoluteSum,
        });

        setTinkModalOpen(true);

        // Save the file
        saveAs(blob, filename);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err, "Error in handleDownloadCsv");
        toast.error("Unable to process Tink report");
        setLoading(false);
      });
  };

  function MyVerticallyCenteredModal(props) {
    if (loading) return <Loading />;
    return (
      <Modal {...props} size="md" centered className="tenants-detail-modal">
        <Modal.Header closeButton className="tenants-modal-header">
          <Modal.Title className="fw-bold h5">User Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="tenants-modal-body">
          <div>
            <Row className="g-3 mb-3">
              <Col md={6}>
                <div className="bg-light p-3 rounded-3 border h-100">
                  <p
                    className="text-muted small mb-1 fw-bold text-uppercase"
                    style={{ fontSize: "11px", letterSpacing: "0.05em" }}
                  >
                    Name
                  </p>
                  <h6 className="mb-0 fw-bold">
                    {singleTenant?.fname} {singleTenant?.lname}
                  </h6>
                </div>
              </Col>
              <Col md={6}>
                <div className="bg-light p-3 rounded-3 border h-100">
                  <p
                    className="text-muted small mb-1 fw-bold text-uppercase"
                    style={{ fontSize: "11px", letterSpacing: "0.05em" }}
                  >
                    DNI/NIE
                  </p>
                  <h6 className="mb-0 fw-bold">
                    {singleTenant?.dni_nie || "-"}
                  </h6>
                </div>
              </Col>
            </Row>
            <Row className="g-3 mb-3">
              <Col md={6}>
                <div className="bg-light p-3 rounded-3 border h-100">
                  <p
                    className="text-muted small mb-1 fw-bold text-uppercase"
                    style={{ fontSize: "11px", letterSpacing: "0.05em" }}
                  >
                    Type Of Employee
                  </p>
                  <h6 className="mb-0 fw-bold">
                    {singleTenant?.type_of_employee || "-"}
                  </h6>
                </div>
              </Col>
              <Col md={6}>
                <div className="bg-light p-3 rounded-3 border h-100">
                  <p
                    className="text-muted small mb-1 fw-bold text-uppercase"
                    style={{ fontSize: "11px", letterSpacing: "0.05em" }}
                  >
                    Nationality
                  </p>
                  <h6 className="mb-0 fw-bold">
                    {singleTenant?.nationality || "-"}
                  </h6>
                </div>
              </Col>
            </Row>
            <Row className="g-3 mb-3">
              <Col md={6}>
                <div className="bg-light p-3 rounded-3 border h-100">
                  <p
                    className="text-muted small mb-1 fw-bold text-uppercase"
                    style={{ fontSize: "11px", letterSpacing: "0.05em" }}
                  >
                    Name Of Company
                  </p>
                  <h6 className="mb-0 fw-bold">
                    {singleTenant?.name_of_company || "-"}
                  </h6>
                </div>
              </Col>
              <Col md={6}>
                <div className="bg-light p-3 rounded-3 border h-100">
                  <p
                    className="text-muted small mb-1 fw-bold text-uppercase"
                    style={{ fontSize: "11px", letterSpacing: "0.05em" }}
                  >
                    Employment Status
                  </p>
                  <h6 className="mb-0 fw-bold">
                    {singleTenant?.employment_status || "-"}
                  </h6>
                </div>
              </Col>
            </Row>
            <Row className="g-3 mb-3">
              <Col md={6}>
                <div className="bg-light p-3 rounded-3 border h-100">
                  <p
                    className="text-muted small mb-1 fw-bold text-uppercase"
                    style={{ fontSize: "11px", letterSpacing: "0.05em" }}
                  >
                    University
                  </p>
                  <h6 className="mb-0 fw-bold">
                    {singleTenant?.name_of_university || "-"}
                  </h6>
                </div>
              </Col>
              <Col md={6}>
                <div className="bg-light p-3 rounded-3 border h-100">
                  <p
                    className="text-muted small mb-1 fw-bold text-uppercase"
                    style={{ fontSize: "11px", letterSpacing: "0.05em" }}
                  >
                    Education
                  </p>
                  <h6 className="mb-0 fw-bold">
                    {singleTenant?.type_of_student || "-"}
                  </h6>
                </div>
              </Col>
            </Row>
            {singleTenant?.previousFeedback?.rating && (
              <Row className="g-3">
                <Col md={12}>
                  <div className="bg-light p-3 rounded-3 border">
                    <p
                      className="text-muted small mb-1 fw-bold text-uppercase"
                      style={{ fontSize: "11px", letterSpacing: "0.05em" }}
                    >
                      Previous Landlord Rating
                    </p>
                    <h6 className="mb-0 fw-bold d-flex align-items-center">
                      {singleTenant.previousFeedback.rating}
                      <AiFillStar color="#F59F18" size={18} className="ms-2" />
                    </h6>
                  </div>
                </Col>
              </Row>
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  const loadSingleTenant = (userid, type) => {
    console.log("Load single user runs");
    const tenantRes = getSingleUser(userid, type);
    console.log(tenantRes);
  };

  const getKycStatus = (value) => {
    if (value) {
      return <p style={{ color: "green" }}>Yes</p>;
    } else {
      return <p style={{ color: "red" }}>No</p>;
    }
  };

  const handleLogin = async (value) => {
    const data = {
      user_id: value._id,
      user_type: "tenant",
    };
    adminLogin(data)
      .then((res) => {
        console.log(res, "CHECK THIS HERE");
        const queryParams = new URLSearchParams({
          token: res.token || "", // Append token
          usertype: "tenant" || "", // Append usertype
          is_verified: res.user.is_verified || true, // Append is_verified
          saveduserid: res.user._id || "", // Append saveduserid
          external_customer_id: res.user._id || "", // Append external_customer_id
          app_type: "skor" || "", // // Append app_type
        });
        console.log(
          new URL(`${REACT_APP_URL}/redirect?${queryParams.toString()}`).href,
          "CHECK HREF HEARE",
        );
        window.open(
          new URL(`${REACT_APP_URL}/redirect?${queryParams.toString()}`).href,
          "_blank",
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleViewAsLandlord = async (tenant) => {
    try {
      const res = await skorLoginAdmin();

      if (res?.success && res?.success_res?.token) {
        const queryParams = new URLSearchParams({
          token: res?.success_res?.token || "",
          usertype: "admin" || "",
          is_verified: res?.success_res?.user.is_verified || true,
          saveduserid: res?.success_res?.user._id || "",
          isAdminUser: "true",
          loggedin_by: "admin",
          redirect_url: `/admin/tenant/${tenant?._id}`
        });
        console.log(
          new URL(`${REACT_APP_URL}/admin-auth?${queryParams.toString()}`).href,
          "ADMIN LOGIN URL",
        );

        window.open(
          new URL(`${REACT_APP_URL}/admin-auth?${queryParams.toString()}`).href,
          "_blank",
        );
      } else {
        toast.error("Error while viewing as landlord");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error logging in as admin");
    }
  }

  const viewDetail = async (value) => {
    setDetailLoadingId(value?._id);
    try {
      const axiosRes = await axiosInstance({
        method: "POST",
        headers: { "x-access-token": localStorage.getItem("token") },
        url: `${BASE_URL}/users/getAllData?type=tenant`,
        data: {
          user_id: value?._id,
        },
      });
      console.log(axiosRes?.data?.tenant, "tenatn data here");
      navigate("/scoreProfile", { state: axiosRes?.data?.tenant });
    } catch (err) {
      console.log(err, "Error in viewDetail");
      toast.error("Unable to load tenant details");
    } finally {
      setDetailLoadingId(null);
    }
  };

  const viewDocument = async (docId) => {
    const formdata = {
      envelopeId: docId,
    };
    downloadDocuSignDoc(formdata)
      .then((res) => {
        console.log(res.zipFile, "Response for download document");

        var binaryString = atob(res.zipFile);
        var len = binaryString.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }

        // Create blob from Uint8Array
        var blob = new Blob([bytes.buffer], { type: "application/pdf" });

        // Create a temporary link element
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "document.pdf";

        // Trigger the download
        link.click();
      })
      .catch((err) => {
        console.log(err, "Error while downloading docusign doc");
      });
  };

  const checkIeDetails = (userDetails) => {
    var check = true;

    if (!userDetails?.ie_details_id[0]) {
      check = false;
      console.log("Failing in no entry");
    }
    if (
      userDetails?.ie_student_id != userDetails?.ie_details_id[0]?.student_id
    ) {
      check = false;
      console.log("Failing in studentid");
    }

    return check;
  };

  const calculateTenantScore = (tenant) => {
    // tenant?.paymentScores?.creditScore?.value
    var result = 0;
    // if (tenant?.gurantor_data[0]?.paymentScores) {
    //   result = tenant?.gurantor_data[0]?.paymentScores?.creditScore?.value;
    // } else {
    //   if (checkIeDetails(tenant)) {
    //     var totalScore = (tenant?.paymentScores?.creditScore?.value || 0) / 2;

    //     if (tenant?.is_university) {
    //       if (totalScore >= 600) {
    //         totalScore += 200;
    //       } else {
    //         totalScore += 400;
    //       }
    //     }
    //     if (totalScore > 850) {
    //       totalScore = 850;
    //     }
    //     result = totalScore;
    //   } else {

    if (tenant?.paymentScores?.creditScore?.value) {
      result = tenant?.paymentScores?.creditScore?.value;
    }
    //   }
    // }
    return result;
  };

  const handleTenantDelete = async (tenant) => {
    if (isDeletingTenant) return;

    setIsDeletingTenant(true);
    try {
      await hardDeleteTenant(tenant?._id);
      if (searchInputRef?.current) {
        searchInputRef.current.value = "";
      }
      loadTenants();
      setDeleteModal(null);
    } finally {
      setIsDeletingTenant(false);
    }
  };

  function nl2br(str) {
    if (typeof str !== "string") return "";
    return str.replace(/\n/g, "<br>");
  }

  const handleDownloadReport = (tenant) => {
    setLoading(true);
    getDocumentAnalysis(tenant?._id)
      .then((res) => {
        console.log(res);
        setShowSummaryModal(true);
        setSummaryData(res?.summary);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleRunForensic = (email) => {
    if (!haveValue(email)) {
      toast.success("Failed to send forensic request");
      return;
    }
    toast.success(`Forensic request sent for ${email}`);
    runForensic(email)
      .then((res) => {})
      .catch((err) => {
        console.log("Error running forensic", err);
      });
  };

  return (
    <>
      <Table responsive hover className="tenants-table">
        <thead>
          <tr>
            <th
              className="sortable-header"
              onClick={() => handleSorting("fname")}
            >
              <span className="sortable-header-content">
                NAME {renderSortIcon("fname")}
              </span>
            </th>
            <th>DNI/NIE</th>
            <th>PASSPORT</th>
            <th>NATIONALITY</th>
            <th
              className="sortable-header"
              onClick={() => handleSorting("credit_score")}
            >
              <span className="sortable-header-content">
                SCORE {renderSortIcon("credit_score")}
              </span>
            </th>
            <th>JOINED FROM</th>
            <th>TENANT TYPE</th>
            <th>DIGITAL VERIFICATION</th>
            <th>BANK VERIFIED</th>
            <th>DOCS UPLOADED</th>
            <th>HAVE GUARANTOR</th>
            <th
              className="sortable-header"
              onClick={() => handleSorting("created_at")}
            >
              <span className="sortable-header-content">
                JOINED ON {renderSortIcon("created_at")}
              </span>
            </th>
            <th>STATUS</th>
            <th>TINK REPORT</th>
            <th>LAST LOGIN FROM</th>
            <th>WORKSPACE</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {tenants.map((tenant, index) => (
            <tr key={index}>
              <td>
                <div className="tenant-name-stack">
                  <span className="tenant-name">
                    {haveValue(tenant?.forensic_name)
                      ? tenant?.forensic_name
                      : `${tenant?.fname} ${tenant?.lname}`}
                  </span>
                  <span className="tenant-email">{tenant?.email || "N/A"}</span>
                </div>
              </td>
              <td className="fw-500">{tenant?.dni_nie || "-"}</td>
              <td className="fw-500">{tenant?.passport_id || "-"}</td>
              <td className="fw-500">{tenant?.nationality || "-"}</td>
              <td>
                <span className="tenant-score-badge">
                  {calculateTenantScore(tenant)}
                  {haveValue(tenant?.kyc_data_from) &&
                  tenant?.kyc_data_from === "Uploaded from CSV"
                    ? " (Bank Statement)"
                    : haveValue(tenant?.kyc_data_from)
                      ? " (Bank Account)"
                      : ""}
                </span>
              </td>
              <td>
                {haveValue(tenant?.referredName) &&
                tenant?.referredName !== "skor" ? (
                  <>
                    <a
                      href={`/landlord?email=${tenant?.referredEmail || tenant?.referredName}`}
                      className="tenant-link"
                    >
                      {tenant?.referredName}
                    </a>
                    {tenant?.agency_name && (
                      <span className="text-muted small">
                        {" "}
                        ({tenant?.agency_name})
                      </span>
                    )}
                  </>
                ) : (
                  <span className="text-muted small">skor</span>
                )}
              </td>
              <td className="fw-500">
                {Array.isArray(tenant?.gurantor_for) &&
                (tenant?.gurantor_for?.length ?? 0) > 0
                  ? "Guarantor"
                  : "Tenant"}
              </td>
              <td>
                {tenant?.onfido_kyc_success ? (
                  <span className="tenant-kyc-yes">Yes</span>
                ) : (
                  <span className="tenant-kyc-no">No</span>
                )}
              </td>
              <td>
                {tenant?.paymentScores ? (
                  <span className="tenant-kyc-yes">Yes</span>
                ) : (
                  <span className="tenant-kyc-no">No</span>
                )}
              </td>
              <td className="text-center fw-600">
                {tenant?.tenant_docs_count || 0}
              </td>
              <td>
                {tenant?.have_gurantor ? (
                  <span className="tenant-kyc-yes">
                    Yes ({tenant?.guarantor_count})
                  </span>
                ) : (
                  <span className="tenant-kyc-no">No</span>
                )}
              </td>
              <td className="text-muted fw-medium small">
                {moment(tenant?.created_at).format("DD MMM YYYY")}
              </td>
              <td>
                {tenant.status ? (
                  <span className="tenant-status-active">Active</span>
                ) : (
                  <span className="tenant-status-inactive">In-Active</span>
                )}
              </td>
              <td>
                {" "}
                {haveValue(tenant?.paymentScores) ? (
                  <>
                    <div className="d-flex justify-content-around">
                      <a onClick={() => handleDownloadCsv(tenant?._id)}>
                        Download
                      </a>
                      <span className="px-1">|</span>
                      <a onClick={() => handleDownloadCsv(tenant?._id, true)}>
                        Modal Report
                      </a>
                    </div>
                  </>
                ) : (
                  <>
                    <span>Not Available</span>
                  </>
                )}
              </td>
              {/* <td>
                <span
                  className={tenant?.paymentScores ? "tenant-link" : "text-muted"}
                  onClick={() =>
                    haveValue(tenant?.paymentScores)
                      ? handleDownloadCsv(tenant?._id)
                      : null
                  }
                  style={{ cursor: tenant?.paymentScores ? "pointer" : "default" }}
                >
                  {haveValue(tenant?.paymentScores)
                    ? "Download"
                    : "Not Available"}
                </span>
              </td> */}
              <td className="text-muted small">
                {tenant?.lastLoginFrom || "-"}
              </td>
              <td>
                <span
                  className="tenant-link"
                  onClick={() => handleShowWorkspaceInfo(tenant?._id)}
                >
                  View
                </span>
              </td>
              <td>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  className="tenant-action-btn"
                  disabled={detailLoadingId === tenant?._id}
                  onClick={() => viewDetail(tenant)}
                >
                  {detailLoadingId === tenant?._id ? "Loading..." : "Details"}
                </Button>
              </td>
              <td>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  className="tenant-action-btn"
                  style={{
                    opacity: tenant?.tenant_docs_count > 0 ? 1 : 0.4,
                    cursor:
                      tenant?.tenant_docs_count > 0 ? "pointer" : "not-allowed",
                  }}
                  onClick={() =>
                    (tenant?.tenant_docs_count || 0) > 0
                      ? handleRunForensic(tenant?.email)
                      : null
                  }
                >
                  Run Forensic
                </Button>
              </td>
              <td>
                <Dropdown>
                  <Dropdown.Toggle
                    as={Button}
                    size="sm"
                    className="tenant-action-btn tenant-dropdown-toggle"
                  >
                    More
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    align="end"
                    className="tenant-actions-menu"
                    popperConfig={{ strategy: "fixed" }}
                    renderOnMount
                  >
                    {adminUser?.role == constants.SUPER_ADMIN && (
                      <>
                        <Dropdown.Item
                          as="button"
                          onClick={(e) => {
                            e.preventDefault();
                            handleLogin(tenant);
                          }}
                        >
                          Login as tenant
                        </Dropdown.Item>
                        <Dropdown.Item
                          as="button"
                          onClick={(e) => {
                            e.preventDefault();
                            handleViewAsLandlord(tenant);
                          }}
                        >
                          View as Landlord
                        </Dropdown.Item>
                        <Dropdown.Item
                          as="button"
                          onClick={() => setDeleteModal(tenant)}
                        >
                          <ImBin /> &nbsp; Delete
                        </Dropdown.Item>
                      </>
                    )}
                    <Dropdown.Item
                      as="button"
                      onClick={(e) => showOtpModal(tenant)}
                    >
                      <IoIosRefresh /> &nbsp; Show OTP
                    </Dropdown.Item>
                    <Dropdown.Item
                      as="button"
                      onClick={(e) => handleDownloadReport(tenant)}
                    >
                      Show Summary
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
          {tenants?.length === 0 && (
            <tr>
              <td colSpan={18} className="text-center py-5 text-muted">
                No Data Found!
              </td>
            </tr>
          )}
          <MyVerticallyCenteredModal
            show={RentModal}
            onHide={() => setRentModal(false)}
          />
        </tbody>
      </Table>

      <Modal
        show={tinkModalOpen}
        size="lg"
        centered
        onHide={() => {
          setTinkModalData({});
          setTinkModalOpen(false);
        }}
      >
        <Modal.Header closeButton className="tenants-modal-header">
          <Modal.Title className="fw-bold h5">Tink Report Summary</Modal.Title>
        </Modal.Header>
        <Modal.Body className="tenants-modal-body">
          <Row className="g-3 mb-4">
            <Col md={6}>
              <div className="bg-light p-3 rounded-3 border">
                <p
                  className="text-muted small mb-1 fw-bold text-uppercase"
                  style={{ fontSize: "11px", letterSpacing: "0.05em" }}
                >
                  Avg 90 Day Transaction
                </p>
                <h5 className="mb-0 fw-bold">
                  {tinkModalData?.average?.toFixed(2) || "0.00"}
                </h5>
              </div>
            </Col>
            <Col md={6}>
              <div className="bg-light p-3 rounded-3 border">
                <p
                  className="text-muted small mb-1 fw-bold text-uppercase"
                  style={{ fontSize: "11px", letterSpacing: "0.05em" }}
                >
                  Total Transactions
                </p>
                <h5 className="mb-0 fw-bold">
                  {tinkModalData?.total_transactions || 0}
                </h5>
              </div>
            </Col>
            <Col md={6}>
              <div className="bg-light p-3 rounded-3 border">
                <p
                  className="text-muted small mb-1 fw-bold text-uppercase"
                  style={{ fontSize: "11px", letterSpacing: "0.05em" }}
                >
                  Total Turnover
                </p>
                <h5 className="mb-0 fw-bold">
                  {tinkModalData?.totalAbsoluteSum?.toFixed(2) || "0.00"}
                </h5>
              </div>
            </Col>
            <Col md={6}>
              <div className="bg-light p-3 rounded-3 border">
                <p
                  className="text-muted small mb-1 fw-bold text-uppercase"
                  style={{ fontSize: "11px", letterSpacing: "0.05em" }}
                >
                  Income
                </p>
                <h5 className="mb-0 fw-bold text-success">
                  {tinkModalData?.positiveSum?.toFixed(2) || "0.00"}
                </h5>
              </div>
            </Col>
          </Row>
          <div className="row g-4">
            <Col md={6}>
              <div className="bg-light p-3 rounded-3 border">
                <p
                  className="text-muted small mb-2 fw-bold text-uppercase"
                  style={{ fontSize: "11px", letterSpacing: "0.05em" }}
                >
                  Income List
                </p>
                {Object.entries(tinkModalData?.object?.income || {}).length >
                0 ? (
                  <ul className="mb-0 ps-3">
                    {Object.entries(tinkModalData?.object?.income || {}).map(
                      ([subCategory, value]) => (
                        <li key={subCategory} className="mb-1">
                          <span className="fw-500">{subCategory}:</span>{" "}
                          {value.toFixed(2)}
                        </li>
                      ),
                    )}
                  </ul>
                ) : (
                  <p className="text-muted small mb-0">No income data</p>
                )}
              </div>
            </Col>
            <Col md={6}>
              <div className="bg-light p-3 rounded-3 border">
                <p
                  className="text-muted small mb-2 fw-bold text-uppercase"
                  style={{ fontSize: "11px", letterSpacing: "0.05em" }}
                >
                  Expense List
                </p>
                {Object.entries(tinkModalData?.object?.expense || {}).length >
                0 ? (
                  <ul className="mb-0 ps-3">
                    {Object.entries(tinkModalData?.object?.expense || {}).map(
                      ([subCategory, value]) => (
                        <li key={subCategory} className="mb-1">
                          <span className="fw-500">{subCategory}:</span>{" "}
                          {value.toFixed(2)}
                        </li>
                      ),
                    )}
                  </ul>
                ) : (
                  <p className="text-muted small mb-0">No expense data</p>
                )}
              </div>
            </Col>
          </div>
        </Modal.Body>
      </Modal>
      <CsvAnalysisReportModal
        show={csvAnalysisModalOpen}
        analysisResponse={csvAnalysisResponse}
        onHide={() => {
          setCsvAnalysisResponse(null);
          setCsvAnalysisModalOpen(false);
        }}
      />
      <Modal
        show={showOtp}
        size="md"
        centered
        onHide={() => {
          setShowOtp(false);
          setOtpTenant({});
        }}
      >
        <Modal.Header closeButton className="tenants-modal-header">
          <Modal.Title className="fw-bold h5">
            OTP for {otpTenant?.fname || ""} {otpTenant?.lname || ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="tenants-modal-body">
          <div className="bg-light p-4 rounded-3 border text-center">
            <p
              className="text-muted small mb-2 fw-bold text-uppercase"
              style={{ fontSize: "11px", letterSpacing: "0.05em" }}
            >
              One-Time Password
            </p>
            <h3
              className="fw-bold mb-0"
              style={{ fontSize: "28px", letterSpacing: "8px" }}
            >
              {otpTenant?.otp || "-----"}
            </h3>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showSummaryModal}
        onHide={() => {
          setShowSummaryModal(false);
          setSummaryData("");
        }}
        centered
        size="lg"
      >
        <Modal.Header closeButton className="tenants-modal-header">
          <Modal.Title className="fw-bold h5">Tenant Summary</Modal.Title>
        </Modal.Header>
        <Modal.Body className="tenants-modal-body">
          <div className="bg-light p-4 rounded-3 border">
            <p
              dangerouslySetInnerHTML={{
                __html: nl2br(summaryData),
              }}
              className="mb-0"
            />
          </div>
        </Modal.Body>
      </Modal>
      <DeleteModal
        isOpen={deleteModal}
        onClose={() => setDeleteModal(null)}
        onConfirm={() => handleTenantDelete(deleteModal)}
        isLoading={isDeletingTenant}
        title="Delete User"
        message={`Are you sure you want to delete ${deleteModal?.fname || ""} ${deleteModal?.lname || ""}? This action is permanent and all data will be lost.`}
      />
    </>
  );
};

export default TenantsList;
